import { useT } from "@/i18n/LanguageContext";
import { useSEO } from "@/lib/useSEO";
import { webPage, breadcrumb } from "@/lib/jsonLd";
import SectionPlaceholder from "@/components/SectionPlaceholder";

export default function Insights() {
  const { t } = useT();
  const title = t("insights.title");
  const eyebrow = t("insights.eyebrow");
  const description = t("insights.intro");

  useSEO({
    title: `${title} | StoicOs`,
    description,
    canonical: "https://stoicos.ai/my-insights",
    og: { title: `${title} | StoicOs`, description },
    jsonLd: [
      webPage({ name: title, description, url: "/my-insights" }),
      breadcrumb([
        { name: "Home", url: "/" },
        { name: title, url: "/my-insights" },
      ]),
    ],
  });

  return (
    <SectionPlaceholder
      source="insights"
      eyebrow={eyebrow}
      title={title}
      subtitleLines={[t("insights.subtitle")]}
      intro={t("insights.intro")}
      comingSoon={t("insights.comingSoon")}
      otherSections={[
        { to: "/stoic-journal",        labelKey: "nav.journal", testid: "insights-explore-journal" },
        { to: "/stoic-training-cards", labelKey: "nav.cards",   testid: "insights-explore-cards" },
        { to: "/my-books",             labelKey: "nav.books",   testid: "insights-explore-books" },
        { to: "/about",                labelKey: "nav.about",   testid: "insights-explore-about" },
      ]}
    >
      <p className="text-[11px] tracking-[0.28em] uppercase text-fog/80">
        {t("insights.byline")}
      </p>
    </SectionPlaceholder>
  );
}
